import Page from 'src/seo/Page'
import Projects from 'src/project/Projects'
import { GetStaticProps } from "next"
import { AlgoliaIndexes } from "projectlink-common"
import initServerIndex from "src/search/algoliaServer"
import topicsService from "src/server/services/topics"

function ProjectsPage({ initialHits, initialTopics }) {
  return (
    <Page
      name={`Heavy industry projects`}
      description={`${initialTopics.map(t => t.name).join(', ')} projects`}
      path={`/projects`}
    >
      <Projects
        initialHits={initialHits}
        initialTopics={initialTopics}
      />
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async (_ctx) => {
  const index = initServerIndex(AlgoliaIndexes.projects)
  const r = await index.search('', { hitsPerPage: 8 })
  const topics = await topicsService.getAll()

  return {
    props: {
      initialHits: r.hits,
      initialTopics: topics,
    },
    revalidate: 3,
  }
}

export default ProjectsPage
